// extracted by mini-css-extract-plugin
export default {"list":"PaginationList_list__RM8jF"};